<template>
  <div>
    <v-progress-linear
      v-slot:progress
      v-if="newAwsAcctExistingClient.awsAccountListing.loadingAccts"
      color="orange"
      indeterminate/>
    <div>
      <div class="note">
        <span>Please choose the account that the new account should mirror. Note, you will have the opportunity to provide updated information.</span>
      </div>

      <material-card>
        <v-data-table
          :search="search"
          :headers="accountHeaders"
          :items="filteredOnboardingAccts"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
          v-model="newAwsAcctExistingClient.awsAccountListing.selectedWorkload"
          item-key="Onboarding_Id"
          show-select
        >
          <template
            slot="headerCell"
            slot-scope="{ header }">
            <span
              class="subheading font-weight-light text-success text-md-left text--darken-3"
              v-text="header.text"
            />
          </template>
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click ="countSelected">
              <td>
                <v-checkbox
                  v-model="props.selected"
                  color="orange"
                  hide-details
                />
              </td>
              <td>{{ props.item.Acct_ID }}</td>
              <td>{{ props.item.Acct_name }}</td>
              <!-- <td>{{ props.item.MP_ID }}</td> -->
              <td>{{ props.item.Registration_Id }}</td>
              <td>{{ props.item.Workload_Status }}</td>
              <td>{{ props.item.Managed_Svc }}</td>
            </tr>
          </template>
        </v-data-table>
        <!-- {{msg}} -->

        <v-container>
          <v-layout
            row
            wrap >
            <v-layout
              column
              wrap
              align-end
              justify-end>
              <v-flex
                xs12
                sm12
                md12
                xl12 >
                <v-btn
                  v-if="newAwsAcctExistingClient.next === true"
                  :disabled="newAwsAcctExistingClient.nextStatus"
                  class="opp-btn"
                  color="warning"
                  @click="setSelectedAccount">Next</v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>

      </material-card>

      <!-- Dialog -->
      <v-dialog
        v-model="newAwsAcctExistingClient.customOnboardingDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-text>
            <v-container fluid>
              <v-layout row wrap style="margin:10px 0">
                <v-flex xs12 sm12 md10 xl10 >Do you have an Opportunity ID for this new account?</v-flex>
                  <v-flex xs12 sm12 md2 xl2 style="align:right">
                    <v-btn-toggle v-model="newAwsAcctExistingClient.q1">
                            <v-btn class="padding-10" style="padding:10px 10px" value="Y">Yes</v-btn>
                            <v-btn class="padding-10" style="padding:10px 10px" value="N">No</v-btn>
                    </v-btn-toggle>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md10 xl10 v-if="newAwsAcctExistingClient.q1==='Y'">Have you completed Opportunity Registration?</v-flex>
                <v-flex xs12 sm12 md2 xl2 v-if="newAwsAcctExistingClient.q1==='Y'" style="align:right">
                    <v-btn-toggle v-model="newAwsAcctExistingClient.q2">
                            <v-btn class="padding-10" style="padding:10px 10px" value="Y">Yes</v-btn>
                            <v-btn class="padding-10" style="padding:10px 10px" value="N">No</v-btn>
                    </v-btn-toggle>
                </v-flex>
                <!-- IF YES -->
                <v-flex xs12 sm12 md12 xl12 v-if="newAwsAcctExistingClient.q2 ==='Y' && newAwsAcctExistingClient.q1 ==='Y'">
                   <v-text-field 
                      label="OppReg ID"
                      v-model="newAwsAcctExistingClient.OppRegId"
                      :error = "newAwsAcctExistingClient.OppRegIdExistError"
                      :error-messages = "newAwsAcctExistingClient.OppRegIdExistErrorMessage"
                      :success = "newAwsAcctExistingClient.OppRegIdExistSuccess"
                      :success-messages = "newAwsAcctExistingClient.OppRegIdExistSuccessMessage"
                     >
                        <template v-slot:append>
                        <v-btn class="my-0" small 
                        :loading ="newAwsAcctExistingClient.OppRegIdExistLoading" validate
                        @click="checkOppregId">
                         <span v-if="newAwsAcctExistingClient.OppregIdValidated === false && newAwsAcctExistingClient.OppRegIdExistSuccess === false">validate</span>
                        <v-icon
                          v-if="newAwsAcctExistingClient.OppregIdValidated === true && newAwsAcctExistingClient.OppRegIdExistSuccess === true"
                          small>check</v-icon>
                        </v-btn>
                       </template> 
                   </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 xl12 v-if="newAwsAcctExistingClient.q2 === 'Y' && newAwsAcctExistingClient.OppRegIdExistSuccess === true">
                   <v-autocomplete
                      v-model="newAwsAcctExistingClient.projectId"
                      :items="filterWorkloads"
                      item-text="Workload_Title"
                      item-value="Project_Id"
                      label="Select Workload"
                    ></v-autocomplete>
                </v-flex>
              
              </v-layout>
              <!-- <v-layout row wrap style="margin:10px 0"> -->
                  <!-- IF NO  -->
                <!-- <v-flex xs12 sm12 md12 xl12 v-if="newAwsAcctExistingClient.q1==='N' || newAwsAcctExistingClient.q2 ==='N'">
                  <span style="font-weight:500">Please complete  <a href="#" @click="oppregLink">Opportunity Registration</a> before you proceed.</span>
                </v-flex>
                <v-flex>
                   <v-btn @click="newAwsAcctExistingClient.customOnboardingDialog = false">Close</v-btn>
                  <v-btn 
                  v-if="newAwsAcctExistingClient.q2==='Y' && newAwsAcctExistingClient.OppRegIdExistSuccess === true"
                   :disabled="newAwsAcctExistingClient.OppRegId === '' || newAwsAcctExistingClient.projectId === ''"
                  class="opp-btn"
                  color="warning"
                  @click="setSelectedNoRegIdAcct">Next</v-btn>
                </v-flex>
              </v-layout> -->

              
            </v-container>
          </v-card-text>
          <v-card-actions>
                <v-btn color="warning" @click="newAwsAcctExistingClient.customOnboardingDialog = false">Close</v-btn>
                        <v-btn 
                        v-if="newAwsAcctExistingClient.q2==='Y' && newAwsAcctExistingClient.OppRegIdExistSuccess === true"
                        :disabled="newAwsAcctExistingClient.OppRegId === '' || newAwsAcctExistingClient.projectId === ''"
                        class="opp-btn"
                        color="warning"
                        @click="setSelectedNoRegIdAcct">Next</v-btn>
              </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>

</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data () {
    return {
      next: false,
      accountHeaders: [
        {
          sortable: true,
          text: 'Actions',
          value: ''
        },
        {
          sortable: true,
          text: 'Onboarding ID',
          value: 'Onboarding_ID',
          align: ' d-none'
        },

        { //
          sortable: true,
          text: 'Account ID',
          value: 'Acct_ID'
        },
        {//
          sortable: true,
          text: 'Account Name',
          value: 'Acct_name'
        },
        {
          sortable: true,
          text: 'Acct_DL',
          value: 'Acct_DL',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'Registration ID',
          value: 'Registration_Id'
        },
        {
          sortable: true,
          text: 'OppReg_Id',
          value: 'OppReg_Id',
          align: ' d-none'
        },
        // {
        //   sortable: true,
        //   text: 'Opportunity Number',
        //   value: 'Opportunity_Number',
        //   align: ' d-none'
        // },
        {
          sortable: true,
          text: 'OppReg Status',
          value: 'Workload_Status'
        },
        {
          sortable: true,
          text: 'Customer_Id',
          value: 'Customer_Id',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'Customer_Name',
          value: 'Customer_Name',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'Contact_Id',
          value: 'Contact Id',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'Project_Id',
          value: 'Project_Id',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'Financial_Id',
          value: 'Financial_Id',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'AcctSecurity_Id',
          value: 'AcctSecurity_Id',
          align: ' d-none'
        },
        {
          sortable: true,
          text: 'Unique_Id',
          value: 'Unique_Id',
          align: ' d-none'
        },
        {//
          sortable: true,
          text: 'Managed Svc',
          value: 'Managed_Svc'
        },
        {
          sortable: true,
          text: 'Agreement',
          value: 'Agreement',
          align: ' d-none'
        }
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {
    ...mapState('user/requestAws', ['newAwsAcctExistingClient']),
    filteredOnboardingAccts () {
      let agreements = ['PPA', 'SPP', 'SPP - FG', 'SPP - EDF', 'EDP - Vale']
      return this.newAwsAcctExistingClient.awsAccountListing.existingAccounts.filter(account => agreements.includes(account.Agreement))
    },
     filterWorkloads(){
      let workloadStatus = [
        'AWS Reg Accepted', 
        'Approved - Tier 1 23% - PPA',
        'Approved - Tier 1 23% - PPA SaaS',
        'Approved - Tier 3 12%',
        'Approved - Tier 2 - Custom EDP',
        'LEGACY - Approved - Tier 1 23% - PPA',
        'LEGACY - Approved - Tier 1 23% - PPA SaaS',
        'LEGACY - Approved - Tier 3 12%',
        'LEGACY - Approved - Tier 2 - Custom EDP']
      return this.newAwsAcctExistingClient.workloads.filter(workload => workloadStatus.includes(workload.Workload_Status)) 
    },
    msg () {
      const selectedRow = this.newAwsAcctExistingClient.awsAccountListing.selectedWorkload[0]
      return selectedRow ? `${JSON.stringify(selectedRow)}` : 'no data selected'
    }
  },
  methods: {
    countSelected () {
      let selected = this.newAwsAcctExistingClient.awsAccountListing.selectedWorkload
      console.log('Registration Id: ', selected[0].Registration_Id)
      let registrationId = selected[0].Registration_Id
      if(registrationId === 'None') {
        this.$store.commit('user/requestAws/setCustomOnboardingDialog', {dialog:true, next:false}) } 
      else {
        this.$store.commit('user/requestAws/setCustomOnboardingDialog', {dialog:false, next:true, seldialog:''}) }

      selected.splice(1, 1)
      if (this.newAwsAcctExistingClient.awsAccountListing.selectedWorkload.length > 0) {
        this.newAwsAcctExistingClient.nextStatus = false
      } else {
        this.newAwsAcctExistingClient.nextStatus = true
      } 
    },
    setSelectedNoRegIdAcct(){
      let account = this.newAwsAcctExistingClient.awsAccountListing.selectedWorkload[0]

      // this.newAwsAcctExistingClient.workloads.filter(workload =>workload )

      console.log('---- workloads ----')
      console.log(this.newAwsAcctExistingClient.workloads)
      console.log('-------------------')

      let selWorkload =  this.newAwsAcctExistingClient.workloads.filter(workload =>   workload.Project_Id === this.newAwsAcctExistingClient.projectId  )
      console.log('*** selworkload if YES***')
      console.log(selWorkload)
      console.log('******************')

      console.log('selected customer: '+ this.newAwsAcctExistingClient.selectedCustomer)

      let selCustomer = this.newAwsAcctExistingClient.customers.filter(res => {return res.Customer_Id === this.newAwsAcctExistingClient.selectedCustomer})
      console.log('####### selCustomer: setSelectedNoRegIdAcct #######')
      console.log(selCustomer)
      console.log(selCustomer[0].Master_Id)
      console.log('###########################')
      let selCustomerAgreement = this.newAwsAcctExistingClient.masterpayers.filter(res => {return res.MP_ID === selCustomer[0].Master_Id})

      if(selCustomerAgreement.length > 0) {
        console.log('selected Customer Agreement: '+ selCustomerAgreement[0].Agreement)
        this.$store.commit('user/requestAws/setSelectedCustomerAgreement', selCustomerAgreement[0].Agreement)
      }


      Object.assign(account, 
      {
        mirrorAcct:'Y', 
        projectId: this.newAwsAcctExistingClient.projectId, 
        workloadType: selWorkload[0].Workload_type, 
        Workload_Status: selWorkload[0].Workload_Status
      });
      this.$store.commit('user/requestAws/setSelecteNoRegIdAcct', account)
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'validation')
      // this.$store.commit('user/requestAws/setExistingLanding', false)
       this.$store.commit('user/requestAws/setExistingLanding', {status: false, dialog:'dialog2', landing: false})
    }, 
    setSelectedAccount () {
      let account = this.newAwsAcctExistingClient.awsAccountListing.selectedWorkload[0]
      console.log('-------- setSelectedAccount: account---------')
      console.log(account)
      console.log('----------------------------------------------')

      console.log('selected customer: '+ this.newAwsAcctExistingClient.selectedCustomer)

      let selCustomer = this.newAwsAcctExistingClient.customers.filter(res => {return res.Customer_Id === this.newAwsAcctExistingClient.selectedCustomer})
      console.log('####### selCustomer: setSelectedAccount #######')
      console.log(selCustomer)
      console.log(selCustomer[0].Master_Id)
      console.log(account)
      console.log('###########################')
      let selCustomerAgreement = this.newAwsAcctExistingClient.masterpayers.filter(res => {return res.MP_ID === selCustomer[0].Master_Id})
      console.log('selCustAgreement Length:' +selCustomerAgreement.length)

      let agreement 
      
      if(selCustomerAgreement.length > 0){
        console.log('selected Customer Agreement: '+ selCustomerAgreement[0].Agreement)
        agreement = selCustomerAgreement[0].Agreement
        account.MP_ID = '' 
        this.$store.commit('user/requestAws/setSelectedCustomerAgreement', agreement)
      }
      this.$store.commit('user/requestAws/setSelectedAccount', account)
      this.$store.commit('user/requestAws/setExistingRegistrationStep', 'validation')
      // this.$store.commit('user/requestAws/setExistingLanding', false)
      this.$store.commit('user/requestAws/setExistingLanding', {status: false, dialog:'dialog2', landing: false})
    },
    checkOppregId(){
      if(this.newAwsAcctExistingClient.OppRegId !== ''){
        let obj = {
        awsType: 'external',
        oppId: this.newAwsAcctExistingClient.OppRegId
      }
        if(this.newAwsAcctExistingClient.OppRegId.substring(0,6) !== 'DXCINT' && this.newAwsAcctExistingClient.OppRegId.substring(0,6) !== 'DXCSUB') {
          console.log('!!!!! validate =====')
          this.$store.dispatch('user/requestAws/onOppIdValidate', obj )
        } else {
          this.$store.commit('user/requestAws/setOppRegIdAvailabilityMessage', { awsType: 'external', type: 'error', message: 'You entered a DXC Internal Opportunity Id'})
        }
      } else {
        this.$store.commit('user/requestAws/setOppRegIdAvailabilityMessage', { awsType: 'external', type:'error',  message: 'Opportunity Registration ID is empty'})
      }
    },
    oppregLink () {
      vm.$router.push({ path: `/request-oppreg/external-oppreg` })
    }

  }
}
</script>
<style>
  .note {
    background-color: #000;
    color: #fff;
    font-weight: 400;
    padding: 10px 35px;
  }
  .v-btn-toggle .v-btn.v-btn--active{
     background-color:#ff9900 !important;
   }
</style>
